"use client";

import { Fragment } from "react";
import Rating from "react-star-review";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Scrollbar, A11y, EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/effect-coverflow";
import "./mbTestimonialSlider.css";
import { useState, useCallback } from "react";
import { getIcon } from "@litonarefin/utils/icons";
import { getStyledIcon } from "@litonarefin/utils/getStyledIcon";

const TestimonialSlider = ({ attributes }) => {
    const {
        slides,
        slideNavigation = "arrows-dots",
        arrowPlacement,
        showScrollBar = false,
        arrowAndDotPosition = "center",
        slidePerColumn = "1",
        slideGap = "20",
        sliderLayout = "slide",
        autoPlay = true,
        autoPalySpeed = "3000",
        pushOnHover = true,
        slideToScroll = "1",
        slideCenter = false,
        grabCursor = false,
        slideLoop = true,
        slideSpeed = "300",
        slideObserver = false,
    } = attributes;

    const [swiperRef, setSwiperRef] = useState();

    const handlePrevious = useCallback(() => {
        swiperRef?.slidePrev();
    }, [swiperRef]);

    const handleNext = useCallback(() => {
        swiperRef?.slideNext();
    }, [swiperRef]);

    const isOutside = arrowPlacement === "outside";

    const btnsClassName = [
        "jlt-slider-btns",
        isOutside ? "jlt-slider-btns--outside" : "",
        `jlt-slider-btns--${arrowAndDotPosition}`,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <Fragment>
            <div className="jlt-slider-wrapper">
                <Swiper
                    onSwiper={setSwiperRef}
                    modules={[Pagination, Scrollbar, A11y, EffectCoverflow, Autoplay]}
                    effect={sliderLayout}
                    loop={slideLoop}
                    spaceBetween={+slideGap}
                    slidesPerView={+slidePerColumn}
                    slidesPerGroup={+slideToScroll}
                    grabCursor={grabCursor}
                    autoplay={{
                        enabled: autoPlay,
                        delay: +autoPalySpeed,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: pushOnHover,
                    }}
                    speed={+slideSpeed}
                    centeredSlides={slideCenter}
                    observer={slideObserver}
                    pagination={
                        slideNavigation === "arrows-dots" || slideNavigation === "dots"
                            ? { clickable: true }
                            : false
                    }
                    watchSlidesProgress={true}
                    scrollbar={showScrollBar}
                    className={`jlt-swiper-slider${isOutside ? " jlt-swiper-slider--outside" : ""}`}
                >
                    {(slides || []).map((slide, index) => {
                        return (
                            <SwiperSlide key={index}>
                                <div className="jlt-slide__contents jlt-w-full jlt-bg-white jlt-p-12 jlt-rounded-lg jlt-flex jlt-flex-col jlt-justify-center jlt-items-center">
                                    <div className="jlt-w-20 jlt-h-20 jlt-mb-6 jlt-rounded-full jlt-overflow-hidden">
                                        <img
                                            className="jlt-w-full"
                                            src={slide.imageURL}
                                            alt="slide image"
                                        />
                                    </div>

                                    <Rating
                                        size={20}
                                        rating={3.5}
                                        count={5}
                                        filledColor={"#FDB022"}
                                        borderColor={"#FDB022"}
                                    />
                                    {slide.title ? <p className="jlt-mt-4 jlt-text-[#1D2939]">{slide.title}</p> : null}

                                    <p className="jlt-mt-4 jlt-text-lg jlt-font-medium jlt-italic jlt-leading-7 ">
                                        {slide.body_content}
                                    </p>

                                    <div className="jlt-mt-6 jlt-flex jlt-flex-col jlt-justify-center jlt-items-center">
                                        <span className="jlt-text-[#1D2939] jlt-text-lg jlt-font-bold">
                                            {slide.author}
                                        </span>
                                        <span className="jlt-text-sm jlt-text-[#667085]">
                                            {slide.designation}
                                        </span>
                                    </div>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>

                <div className={btnsClassName}>
                    <button onClick={handlePrevious} aria-label="Previous">
                        {getStyledIcon(getIcon("arrowRightAlt"), "var(--primary)", undefined, {
                            transform: "rotate(180deg)",
                        })}
                    </button>
                    <button onClick={handleNext} aria-label="Next">
                        {getStyledIcon(getIcon("arrowRightAlt"), "var(--primary)")}
                    </button>
                </div>
            </div>
        </Fragment>
    );
};

export default TestimonialSlider;
